export const AUTH_REQUEST = "AUTH_REQUEST"
export const AUTH_DONE = "AUTH_DONE"
export const REGISTER_SUCCESS = "REGISTER_SUCCESS"
export const REGISTER_FAIL = "REGISTER_FAIL"
export const USER_LOADED = "USER_LOADED"
export const PARTNER_VERIFIED = "PARTNER_VERIFIED"
export const PARTNER_DETAILS = "PARTNER_DETAILS"
export const AUTH_ERROR = "AUTH_ERROR"
export const RESTAURANTS_LOADED = "RESTAURANTS_LOADED"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAIL = "LOGIN_FAIL"
export const SET_LOADING_MENUS = "SET_LOADING_MENUS"
export const GET_RESTAURANT_MENU_FAIL = "GET_RESTAURANT_MENU_FAIL"
export const ACCEPTING_INVITE = "ACCEPTING_INVITE"
export const REJECTING_INVITE = "REJECTING_INVITE"
export const INVITE_OPERATION_LOADING = "INVITE_OPERATION_LOADING"
export const SUBMITTING_FORM = "SUBMITTING_FORM"
export const PARTNER_OPERATION_LOADING = "PARTNER_OPERATION_LOADING"
export const SET_SUGGESTING = "SET_SUGGESTING"
export const LOGOUT = "LOGOUT"
export const SAVE_PREFERENCES_SUCCESS = "SAVE_PREFERENCES_SUCCESS"
export const INVITE_SUCCESS = "INVITE_SUCCESS"
export const INVITE_FAILURE = "INVITE_FAILURE"
export const RESET_INVITE = "RESET_INVITE"
export const MOBILE_VERIFICATION_SUCCESS = "MOBILE_VERIFICATION_SUCCESS"
export const SECRETCODE_SUCCESS = "SECRETCODE_SUCCESS"
export const PLACING_ORDER = "PLACING_ORDER"
export const SAVING_ADDRESS = "SAVING_ADDRESS"
export const LOADING_MODAL_ACTION = "LOADING_MODAL_ACTION"
export const SUGGEST_RESTAURANT_NAME = "SUGGEST_RESTAURANT_NAME"
export const ACCEPT_SUGGESTION = "ACCEPT_SUGGESTION"
export const DECLINE_SUGGESTION = "DECLINE_SUGGESTION"
export const CHANGE_RESTAURANT = "CHANGE_RESTAURANT"
export const ADD_OR_REMOVE_ITEM = "ADD_OR_REMOVE_ITEM"
export const SELECTED_ITEM_OPTIONS = "SELECTED_ITEM_OPTIONS"
export const GET_RESTAURANTS = "GET_RESTAURANTS"
export const GETTING_RESTAURANTS = "GETING_RESTAURANTS"
export const GET_RESTAURANT_MENU = "GET_RESTAURANT_MENU"
export const SET_MESSAGES = "SET_MESSAGES"
export const SET_CHAT_AUTH_TOKEN = "SET_CHAT_AUTH_TOKEN"
export const PARTNER_DETAILS_FETCHED = "PARTNER_DETAILS_FETCHED"
export const SET_NEW_MESSAGE = "SET_NEW_MESSAGE"
export const FAILED_TO_FETCH_PARTNER = "FAILED_TO_FETCH_PARTNER"
export const SUGGESTED_MENU_ITEM = "SUGGESTED_MENU_ITEM"
export const WHICH_ITEMS_ARE_SUGGESTED = "WHICH_ITEMS_ARE_SUGGESTED"
export const RESET_WHICH_ITEMS_ARE_SUGGESTED = "RESET_WHICH_ITEMS_ARE_SUGGESTED"
export const REMOVE_SUGGESTED_ITEM = "REMOVE_SUGGESTED_ITEM"
export const REMOVE_ITEM_FROM_CART = "REMOVE_ITEM_FROM_CART"
export const EMPTY_DELIVERY_DOT_COM_CART = "EMPTY_DELIVERY_DOT_COM_CART"
export const TOGGLE_ADD_TO_CART_POPUP = "TOGGLE_ADD_TO_CART_POPUP"
export const REMOVE_ITEM_FROM_SUGGESTED_LIST = "REMOVE_ITEM_FROM_SUGGESTED_LIST"
export const GET_CART_ITEMS_FROM_DELIVERY = "GET_CART_ITEMS_FROM_DELIVERY"
export const VIEW_ORDER = "VIEW_ORDER"
export const FAILED_TO_FETCH_CARTS = "FAILED_TO_FETCH_CARTS"
export const TO_BE_VERIFIED_NUMBER = "TO_BE_VERIFIED_NUMBER"
export const FETCHING_CART_FOR_BILLING = "FETCHING_CART_FOR_BILLING"
export const UPDATE_ADDRESS_SUCCESS = "UPDATE_ADDRESS_SUCCESS"
export const SET_PARTNER_CART_STATUS = "SET_PARTNER_CART_STATUS"
export const SET_CART_STATUS = "SET_CART_STATUS"
export const SET_SUGGESTED_ITEMS = "SET_SUGGESTED_ITEMS"
export const PARTNER_READY_FOR_CHECKOUT = "PARTNER_READY_FOR_CHECKOUT"
export const SAVE_ADDRESS = "SAVE_ADDRESS"
export const PAY_STATUS = "PAY_STATUS"
export const PARTNER_CONFIRMED_CHECKOUT_DETAILS =
  "PARTNER_CONFIRMED_CHECKOUT_DETAILS"
export const SET_CHECKOUT_HEADER_MESSAGE = "SET_CHECKOUT_HEADER_MESSAGE"
export const SET_CHECKOUT_DETAIL_CONFIRMED = "SET_CHECKOUT_DETAIL_CONFIRMED"
export const SET_PAYMENT_STATUS = "SET_PAYMENT_STATUS"
export const USER_UPDATED = "USER_UPDATED"
export const SET_USER_ONLINE = "SET_USER_ONLINE"
export const SET_PARTNER_ONLINE = "SET_PARTNER_ONLINE"
export const SET_PARTNER_ADDRESS = "SET_PARTNER_ADDRESS"
export const ADDED_TO_THEIR_CART = "ADDED_TO_THEIR_CART"
export const SHOW_READY_MODAL = "SHOW_READY_MODAL"
export const SET_PARTNER_DETAILS = "SET_PARTNER_DETAILS"
export const REMOVED_FROM_THEIR_CART = "REMOVED_FROM_THEIR_CART"
export const NOTIFY_SUBSCRIBED = "NOTIFY_SUBSCRIBED"
export const IS_DELIVERABLE = "IS_DELIVERABLE"
export const IS_NOT_DELIVERABLE = "IS_NOT_DELIVERABLE"
export const SET_USER_PAYMENT_DETAILS = "SET_USER_PAYMENT_DETAILS"
export const MOBILE_VERIFICATION_FAILED = "MOBILE_VERIFICATION_FAILED"
export const SET_LOADER = "SET_LOADER"
export const DEV__TOGGLE_ON_BACKGROUND_OFFLINE =
  "DEV__TOGGLE_ON_BACKGROUND_OFFLINE"
export const DEV__RESET = "DEV__RESET"
export const JOURNAL_ANSWERS = "JOURNAL_ANSWERS"
